module.exports = __webpack_public_path__ + "img/process-icon-2.e818b807.svg";